/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumProviderBillingType = "duplicate" | "fullTime" | "noLongerEmployed" | "nonBilled" | "partTime" | "resource" | "unknown" | "%future added value";
export type EnumProviderContactArchivedReason = "doNotContact" | "none" | "unreachable" | "%future added value";
export type EnumProviderContactType = "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumProviderDemoConfigurationType = "default" | "lumabot" | "%future added value";
export type EnumProviderDisplayStatus = "active" | "pending" | "suspended" | "%future added value";
export type EnumProviderExternalIdSource = "acomrapidpm" | "acuityscheduling" | "adspm" | "advancedmd" | "allmeds" | "allscriptspm" | "allscriptsunity" | "amazingcharts" | "athenahealth" | "athenamdp" | "avimark" | "brightree" | "carecloud" | "caretracker" | "centricityps" | "cerner" | "clearpractice" | "clinicient" | "clinix" | "clinux" | "compulink" | "curemd" | "dentrix" | "drchrono" | "dsnpm" | "duxware" | "eclinicalmobile" | "eclinicalworks10E" | "eclinicalworkssql" | "email" | "emapm" | "emds" | "epic" | "epicconfirmationpickup" | "ezderm" | "ezemrx" | "fullslate" | "gcalendar" | "genericfhir" | "ggastromobile" | "gmed" | "greenwayintergy" | "greenwayprimesuite" | "healthnautica" | "hl7" | "hl7Pickup" | "imedicware" | "imsgo" | "isalus" | "kareo" | "keymedical" | "labretriever" | "lumacare" | "lumamock" | "lytec" | "managementplus" | "mdoffice" | "medevolve" | "medicalmaster" | "medicalmastermind" | "medinformatix" | "meditechexpanse" | "meditouch" | "medstreaming" | "mi7" | "micromd" | "mindbody" | "modmedfhir" | "mwtherapy" | "nextech" | "nextechfhir" | "nextechpracticeplus" | "nextgen" | "none" | "nuemd" | "officeally" | "oncoemrfilepickup" | "onetouch" | "openemr" | "optimispt" | "phoenixortho" | "practicefusion" | "practiceperfect" | "raintree" | "recall" | "referral" | "revflow" | "roche" | "sms" | "somnoware" | "successehs" | "systemedx" | "theraoffice" | "valant" | "voice" | "webedoctor" | "webpt" | "%future added value";
export type EnumProviderGender = "female" | "male" | "nonbinary" | "unknown" | "%future added value";
export type EnumProviderPasswordHashAlgorithm = "bcrypt" | "md5" | "sha256" | "sha512" | "%future added value";
export type EnumProviderSalesforceDataAccountLifeline = "active" | "assigned" | "churned" | "converted" | "disqualified" | "nurture" | "openOpportunity" | "partnered" | "salesAccepted" | "salesQualified" | "trial" | "trialEndedNoConversion" | "unassigned" | "working" | "%future added value";
export type EnumProviderSalesforceDataBoardSegment = "core" | "majors" | "reseller" | "strategic" | "sub20" | "unknown" | "%future added value";
export type EnumProviderSalesforceDataHealthStatus = "advocate" | "churnRisk" | "green" | "healthy" | "neutral" | "poorFit" | "red" | "yellow" | "%future added value";
export type EnumProviderSalesforceDataLifeline = "active" | "churn" | "converted" | "trial" | "%future added value";
export type EnumProviderSalesforceDataOnboardingStage = "customerSuccessIntroduction" | "customization" | "discoveryCall" | "fullyImplemented" | "goLive" | "integration" | "kickoff" | "readyToLaunch" | "staffTraining" | "testing" | "%future added value";
export type EnumProviderSecondaryExternalIdSource = "acomrapidpm" | "acuityscheduling" | "adspm" | "advancedmd" | "allmeds" | "allscriptspm" | "allscriptsunity" | "amazingcharts" | "athenahealth" | "athenamdp" | "avimark" | "brightree" | "carecloud" | "caretracker" | "centricityps" | "cerner" | "clearpractice" | "clinicient" | "clinix" | "clinux" | "compulink" | "curemd" | "dentrix" | "drchrono" | "dsnpm" | "duxware" | "eclinicalmobile" | "eclinicalworks10E" | "eclinicalworkssql" | "email" | "emapm" | "emds" | "epic" | "epicconfirmationpickup" | "ezderm" | "ezemrx" | "fullslate" | "gcalendar" | "genericfhir" | "ggastromobile" | "gmed" | "greenwayintergy" | "greenwayprimesuite" | "healthnautica" | "hl7" | "hl7Pickup" | "imedicware" | "imsgo" | "isalus" | "kareo" | "keymedical" | "labretriever" | "lumacare" | "lumamock" | "lytec" | "managementplus" | "mdoffice" | "medevolve" | "medicalmaster" | "medicalmastermind" | "medinformatix" | "meditechexpanse" | "meditouch" | "medstreaming" | "mi7" | "micromd" | "mindbody" | "modmedfhir" | "mwtherapy" | "nextech" | "nextechfhir" | "nextechpracticeplus" | "nextgen" | "none" | "nuemd" | "officeally" | "oncoemrfilepickup" | "onetouch" | "openemr" | "optimispt" | "phoenixortho" | "practicefusion" | "practiceperfect" | "raintree" | "recall" | "referral" | "revflow" | "roche" | "sms" | "somnoware" | "successehs" | "systemedx" | "theraoffice" | "valant" | "voice" | "webedoctor" | "webpt" | "%future added value";
export type EnumProviderSource = "integrator" | "patientReferralForm" | "ui" | "upload" | "%future added value";
export type EnumProviderTelehealthVendorsZoomStatus = "active" | "inactive" | "pending" | "%future added value";
export type EnumProviderType = "doctor" | "guest" | "patient" | "staff" | "system" | "%future added value";
export type FilterFindManyProviderInput = {
    name?: string | null | undefined;
    normalizedName?: string | null | undefined;
    firstname?: string | null | undefined;
    lastname?: string | null | undefined;
    middlename?: string | null | undefined;
    displayPhone?: string | null | undefined;
    displayStatus?: EnumProviderDisplayStatus | null | undefined;
    email?: string | null | undefined;
    safeId?: string | null | undefined;
    type?: EnumProviderType | null | undefined;
    roles?: Array<string | null> | null | undefined;
    rolesByUser?: ProviderRolesByUserInput | null | undefined;
    organization?: string | null | undefined;
    contact?: Array<ProviderContactInput | null> | null | undefined;
    doNotContact?: boolean | null | undefined;
    doNotContactMessage?: string | null | undefined;
    groups?: Array<string | null> | null | undefined;
    stripeCustomerId?: string | null | undefined;
    stripeSubscriptionId?: string | null | undefined;
    salesforceId?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    lastLogin?: unknown | null | undefined;
    active?: number | null | undefined;
    master?: boolean | null | undefined;
    language?: string | null | undefined;
    user?: string | null | undefined;
    setting?: string | null | undefined;
    settings?: unknown | null | undefined;
    address?: string | null | undefined;
    address2?: string | null | undefined;
    city?: string | null | undefined;
    state?: string | null | undefined;
    country?: string | null | undefined;
    postcode?: string | null | undefined;
    gender?: EnumProviderGender | null | undefined;
    allowedIps?: Array<string | null> | null | undefined;
    avatar?: string | null | undefined;
    publicKey?: string | null | undefined;
    directMessagingEmail?: string | null | undefined;
    demoConfiguration?: ProviderDemoConfigurationInput | null | undefined;
    website?: string | null | undefined;
    _id?: string | null | undefined;
    deptCode?: string | null | undefined;
    phonetic?: string | null | undefined;
    alternativeName?: string | null | undefined;
    schedulable?: boolean | null | undefined;
    isReferringProvider?: boolean | null | undefined;
    isRenderingProvider?: boolean | null | undefined;
    visible?: boolean | null | undefined;
    npi?: number | null | undefined;
    source?: EnumProviderSource | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    biography?: string | null | undefined;
    biographyUrl?: string | null | undefined;
    headshot?: string | null | undefined;
    billingType?: EnumProviderBillingType | null | undefined;
    mergedInto?: string | null | undefined;
    telehealthVendors?: ProviderTelehealthVendorsInput | null | undefined;
    specialInstructions?: string | null | undefined;
    salesforceData?: ProviderSalesforceDataInput | null | undefined;
    externalId?: ProviderExternalIdInput | null | undefined;
    secondaryExternalId?: ProviderSecondaryExternalIdInput | null | undefined;
    dateOfBirth?: ProviderDateOfBirthInput | null | undefined;
    twoFactorAuthSecret?: ProviderTwoFactorAuthSecretInput | null | undefined;
    stats?: ProviderStatsInput | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyProviderInput | null | undefined;
    OR?: Array<FilterFindManyProviderInput> | null | undefined;
    AND?: Array<FilterFindManyProviderInput> | null | undefined;
};
export type ProviderRolesByUserInput = {
    referringProvider?: Array<string | null> | null | undefined;
    renderingProvider?: Array<string | null> | null | undefined;
    _id?: string | null | undefined;
};
export type ProviderContactInput = {
    type?: EnumProviderContactType | null | undefined;
    value?: string | null | undefined;
    active?: boolean | null | undefined;
    archived?: boolean | null | undefined;
    archivedReason?: EnumProviderContactArchivedReason | null | undefined;
    archivedMessage?: string | null | undefined;
};
export type ProviderDemoConfigurationInput = {
    type?: EnumProviderDemoConfigurationType | null | undefined;
    _id?: string | null | undefined;
};
export type ProviderTelehealthVendorsInput = {
    zoom?: ProviderTelehealthVendorsZoomInput | null | undefined;
    _id?: string | null | undefined;
};
export type ProviderTelehealthVendorsZoomInput = {
    id?: string | null | undefined;
    status?: EnumProviderTelehealthVendorsZoomStatus | null | undefined;
    _id?: string | null | undefined;
};
export type ProviderSalesforceDataInput = {
    customerSuccessManager?: PatientSalesforceDataCustomerSuccessManagerInput | null | undefined;
    provisioning?: Array<string | null> | null | undefined;
    respectProvisioning?: boolean | null | undefined;
    lifeline?: EnumProviderSalesforceDataLifeline | null | undefined;
    mrr?: number | null | undefined;
    renewalDate?: unknown | null | undefined;
    providers?: number | null | undefined;
    specialty?: string | null | undefined;
    referralTrialLimit?: number | null | undefined;
    recordType?: string | null | undefined;
    domesticAccessRequired?: boolean | null | undefined;
    goLiveAt?: unknown | null | undefined;
    fullyImplementedAt?: unknown | null | undefined;
    contractSignedAt?: unknown | null | undefined;
    contractLength?: number | null | undefined;
    ein?: string | null | undefined;
    healthStatus?: EnumProviderSalesforceDataHealthStatus | null | undefined;
    boardSegment?: EnumProviderSalesforceDataBoardSegment | null | undefined;
    onboardingStage?: EnumProviderSalesforceDataOnboardingStage | null | undefined;
    accountLifeline?: EnumProviderSalesforceDataAccountLifeline | null | undefined;
};
export type PatientSalesforceDataCustomerSuccessManagerInput = {
    name?: string | null | undefined;
    email?: string | null | undefined;
    phone?: string | null | undefined;
};
export type ProviderExternalIdInput = {
    source?: EnumProviderExternalIdSource | null | undefined;
    value?: string | null | undefined;
};
export type ProviderSecondaryExternalIdInput = {
    source?: EnumProviderSecondaryExternalIdSource | null | undefined;
    value?: string | null | undefined;
};
export type ProviderDateOfBirthInput = {
    year?: number | null | undefined;
    month?: number | null | undefined;
    day?: number | null | undefined;
};
export type ProviderTwoFactorAuthSecretInput = {
    enabled?: boolean | null | undefined;
};
export type ProviderStatsInput = {
    oldestAppointment?: unknown | null | undefined;
};
export type OperatorsFilterFindManyProviderInput = {
    name?: NameOperatorsFilterFindManyProviderInput | null | undefined;
    normalizedName?: NormalizedNameOperatorsFilterFindManyProviderInput | null | undefined;
    firstname?: FirstnameOperatorsFilterFindManyProviderInput | null | undefined;
    lastname?: LastnameOperatorsFilterFindManyProviderInput | null | undefined;
    middlename?: MiddlenameOperatorsFilterFindManyProviderInput | null | undefined;
    displayPhone?: DisplayPhoneOperatorsFilterFindManyProviderInput | null | undefined;
    displayStatus?: DisplayStatusOperatorsFilterFindManyProviderInput | null | undefined;
    email?: EmailOperatorsFilterFindManyProviderInput | null | undefined;
    password?: PasswordOperatorsFilterFindManyProviderInput | null | undefined;
    passwordHashAlgorithm?: PasswordHashAlgorithmOperatorsFilterFindManyProviderInput | null | undefined;
    passwordUpdatedAt?: PasswordUpdatedAtOperatorsFilterFindManyProviderInput | null | undefined;
    safeId?: SafeIdOperatorsFilterFindManyProviderInput | null | undefined;
    resetPasswordToken?: ResetPasswordTokenOperatorsFilterFindManyProviderInput | null | undefined;
    resetPasswordExpires?: ResetPasswordExpiresOperatorsFilterFindManyProviderInput | null | undefined;
    type?: TypeOperatorsFilterFindManyProviderInput | null | undefined;
    roles?: RolesOperatorsFilterFindManyProviderInput | null | undefined;
    rolesByUser?: RolesByUserOperatorsFilterFindManyProviderInput | null | undefined;
    organization?: OrganizationOperatorsFilterFindManyProviderInput | null | undefined;
    contact?: ContactOperatorsFilterFindManyProviderInput | null | undefined;
    doNotContact?: DoNotContactOperatorsFilterFindManyProviderInput | null | undefined;
    doNotContactMessage?: DoNotContactMessageOperatorsFilterFindManyProviderInput | null | undefined;
    groups?: GroupsOperatorsFilterFindManyProviderInput | null | undefined;
    stripeCustomerId?: StripeCustomerIdOperatorsFilterFindManyProviderInput | null | undefined;
    stripeSubscriptionId?: StripeSubscriptionIdOperatorsFilterFindManyProviderInput | null | undefined;
    salesforceId?: SalesforceIdOperatorsFilterFindManyProviderInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyProviderInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyProviderInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyProviderInput | null | undefined;
    lastLogin?: LastLoginOperatorsFilterFindManyProviderInput | null | undefined;
    token?: TokenOperatorsFilterFindManyProviderInput | null | undefined;
    active?: ActiveOperatorsFilterFindManyProviderInput | null | undefined;
    master?: MasterOperatorsFilterFindManyProviderInput | null | undefined;
    language?: LanguageOperatorsFilterFindManyProviderInput | null | undefined;
    user?: UserOperatorsFilterFindManyProviderInput | null | undefined;
    setting?: SettingOperatorsFilterFindManyProviderInput | null | undefined;
    settings?: SettingsOperatorsFilterFindManyProviderInput | null | undefined;
    address?: AddressOperatorsFilterFindManyProviderInput | null | undefined;
    address2?: Address2OperatorsFilterFindManyProviderInput | null | undefined;
    city?: CityOperatorsFilterFindManyProviderInput | null | undefined;
    state?: StateOperatorsFilterFindManyProviderInput | null | undefined;
    country?: CountryOperatorsFilterFindManyProviderInput | null | undefined;
    postcode?: PostcodeOperatorsFilterFindManyProviderInput | null | undefined;
    gender?: GenderOperatorsFilterFindManyProviderInput | null | undefined;
    allowedIps?: AllowedIpsOperatorsFilterFindManyProviderInput | null | undefined;
    avatar?: AvatarOperatorsFilterFindManyProviderInput | null | undefined;
    publicKey?: PublicKeyOperatorsFilterFindManyProviderInput | null | undefined;
    directMessagingEmail?: DirectMessagingEmailOperatorsFilterFindManyProviderInput | null | undefined;
    demoConfiguration?: DemoConfigurationOperatorsFilterFindManyProviderInput | null | undefined;
    website?: WebsiteOperatorsFilterFindManyProviderInput | null | undefined;
    _id?: _idOperatorsFilterFindManyProviderInput | null | undefined;
    deptCode?: DeptCodeOperatorsFilterFindManyProviderInput | null | undefined;
    phonetic?: PhoneticOperatorsFilterFindManyProviderInput | null | undefined;
    alternativeName?: AlternativeNameOperatorsFilterFindManyProviderInput | null | undefined;
    schedulable?: SchedulableOperatorsFilterFindManyProviderInput | null | undefined;
    isReferringProvider?: IsReferringProviderOperatorsFilterFindManyProviderInput | null | undefined;
    isRenderingProvider?: IsRenderingProviderOperatorsFilterFindManyProviderInput | null | undefined;
    visible?: VisibleOperatorsFilterFindManyProviderInput | null | undefined;
    npi?: NpiOperatorsFilterFindManyProviderInput | null | undefined;
    source?: SourceOperatorsFilterFindManyProviderInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyProviderInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyProviderInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyProviderInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyProviderInput | null | undefined;
    biography?: BiographyOperatorsFilterFindManyProviderInput | null | undefined;
    biographyUrl?: BiographyUrlOperatorsFilterFindManyProviderInput | null | undefined;
    headshot?: HeadshotOperatorsFilterFindManyProviderInput | null | undefined;
    billingType?: BillingTypeOperatorsFilterFindManyProviderInput | null | undefined;
    mergedInto?: MergedIntoOperatorsFilterFindManyProviderInput | null | undefined;
    externalRawSource?: ExternalRawSourceOperatorsFilterFindManyProviderInput | null | undefined;
    telehealthVendors?: TelehealthVendorsOperatorsFilterFindManyProviderInput | null | undefined;
    specialInstructions?: SpecialInstructionsOperatorsFilterFindManyProviderInput | null | undefined;
};
export type NameOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type NormalizedNameOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FirstnameOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type LastnameOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type MiddlenameOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DisplayPhoneOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DisplayStatusOperatorsFilterFindManyProviderInput = {
    gt?: EnumProviderDisplayStatus | null | undefined;
    gte?: EnumProviderDisplayStatus | null | undefined;
    lt?: EnumProviderDisplayStatus | null | undefined;
    lte?: EnumProviderDisplayStatus | null | undefined;
    ne?: EnumProviderDisplayStatus | null | undefined;
    in?: Array<EnumProviderDisplayStatus | null> | null | undefined;
    nin?: Array<EnumProviderDisplayStatus | null> | null | undefined;
    regex?: EnumProviderDisplayStatus | null | undefined;
};
export type EmailOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PasswordOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PasswordHashAlgorithmOperatorsFilterFindManyProviderInput = {
    gt?: EnumProviderPasswordHashAlgorithm | null | undefined;
    gte?: EnumProviderPasswordHashAlgorithm | null | undefined;
    lt?: EnumProviderPasswordHashAlgorithm | null | undefined;
    lte?: EnumProviderPasswordHashAlgorithm | null | undefined;
    ne?: EnumProviderPasswordHashAlgorithm | null | undefined;
    in?: Array<EnumProviderPasswordHashAlgorithm | null> | null | undefined;
    nin?: Array<EnumProviderPasswordHashAlgorithm | null> | null | undefined;
    regex?: EnumProviderPasswordHashAlgorithm | null | undefined;
};
export type PasswordUpdatedAtOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type SafeIdOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ResetPasswordTokenOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ResetPasswordExpiresOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type TypeOperatorsFilterFindManyProviderInput = {
    gt?: EnumProviderType | null | undefined;
    gte?: EnumProviderType | null | undefined;
    lt?: EnumProviderType | null | undefined;
    lte?: EnumProviderType | null | undefined;
    ne?: EnumProviderType | null | undefined;
    in?: Array<EnumProviderType | null> | null | undefined;
    nin?: Array<EnumProviderType | null> | null | undefined;
    regex?: EnumProviderType | null | undefined;
};
export type RolesOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type RolesByUserOperatorsFilterFindManyProviderInput = {
    gt?: ProviderRolesByUserInput | null | undefined;
    gte?: ProviderRolesByUserInput | null | undefined;
    lt?: ProviderRolesByUserInput | null | undefined;
    lte?: ProviderRolesByUserInput | null | undefined;
    ne?: ProviderRolesByUserInput | null | undefined;
    in?: Array<ProviderRolesByUserInput | null> | null | undefined;
    nin?: Array<ProviderRolesByUserInput | null> | null | undefined;
    regex?: ProviderRolesByUserInput | null | undefined;
};
export type OrganizationOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ContactOperatorsFilterFindManyProviderInput = {
    gt?: ProviderContactInput | null | undefined;
    gte?: ProviderContactInput | null | undefined;
    lt?: ProviderContactInput | null | undefined;
    lte?: ProviderContactInput | null | undefined;
    ne?: ProviderContactInput | null | undefined;
    in?: Array<ProviderContactInput | null> | null | undefined;
    nin?: Array<ProviderContactInput | null> | null | undefined;
    regex?: ProviderContactInput | null | undefined;
};
export type DoNotContactOperatorsFilterFindManyProviderInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type DoNotContactMessageOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GroupsOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StripeCustomerIdOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StripeSubscriptionIdOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SalesforceIdOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterFindManyProviderInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type LastLoginOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type TokenOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ActiveOperatorsFilterFindManyProviderInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type MasterOperatorsFilterFindManyProviderInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type LanguageOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UserOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SettingOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SettingsOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type AddressOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type Address2OperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type CityOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StateOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type CountryOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PostcodeOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GenderOperatorsFilterFindManyProviderInput = {
    gt?: EnumProviderGender | null | undefined;
    gte?: EnumProviderGender | null | undefined;
    lt?: EnumProviderGender | null | undefined;
    lte?: EnumProviderGender | null | undefined;
    ne?: EnumProviderGender | null | undefined;
    in?: Array<EnumProviderGender | null> | null | undefined;
    nin?: Array<EnumProviderGender | null> | null | undefined;
    regex?: EnumProviderGender | null | undefined;
};
export type AllowedIpsOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AvatarOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PublicKeyOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DirectMessagingEmailOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DemoConfigurationOperatorsFilterFindManyProviderInput = {
    gt?: ProviderDemoConfigurationInput | null | undefined;
    gte?: ProviderDemoConfigurationInput | null | undefined;
    lt?: ProviderDemoConfigurationInput | null | undefined;
    lte?: ProviderDemoConfigurationInput | null | undefined;
    ne?: ProviderDemoConfigurationInput | null | undefined;
    in?: Array<ProviderDemoConfigurationInput | null> | null | undefined;
    nin?: Array<ProviderDemoConfigurationInput | null> | null | undefined;
    regex?: ProviderDemoConfigurationInput | null | undefined;
};
export type WebsiteOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeptCodeOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PhoneticOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AlternativeNameOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SchedulableOperatorsFilterFindManyProviderInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type IsReferringProviderOperatorsFilterFindManyProviderInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type IsRenderingProviderOperatorsFilterFindManyProviderInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type VisibleOperatorsFilterFindManyProviderInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type NpiOperatorsFilterFindManyProviderInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type SourceOperatorsFilterFindManyProviderInput = {
    gt?: EnumProviderSource | null | undefined;
    gte?: EnumProviderSource | null | undefined;
    lt?: EnumProviderSource | null | undefined;
    lte?: EnumProviderSource | null | undefined;
    ne?: EnumProviderSource | null | undefined;
    in?: Array<EnumProviderSource | null> | null | undefined;
    nin?: Array<EnumProviderSource | null> | null | undefined;
    regex?: EnumProviderSource | null | undefined;
};
export type CreatedByOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type BiographyOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type BiographyUrlOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type HeadshotOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type BillingTypeOperatorsFilterFindManyProviderInput = {
    gt?: EnumProviderBillingType | null | undefined;
    gte?: EnumProviderBillingType | null | undefined;
    lt?: EnumProviderBillingType | null | undefined;
    lte?: EnumProviderBillingType | null | undefined;
    ne?: EnumProviderBillingType | null | undefined;
    in?: Array<EnumProviderBillingType | null> | null | undefined;
    nin?: Array<EnumProviderBillingType | null> | null | undefined;
    regex?: EnumProviderBillingType | null | undefined;
};
export type MergedIntoOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ExternalRawSourceOperatorsFilterFindManyProviderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type TelehealthVendorsOperatorsFilterFindManyProviderInput = {
    gt?: ProviderTelehealthVendorsInput | null | undefined;
    gte?: ProviderTelehealthVendorsInput | null | undefined;
    lt?: ProviderTelehealthVendorsInput | null | undefined;
    lte?: ProviderTelehealthVendorsInput | null | undefined;
    ne?: ProviderTelehealthVendorsInput | null | undefined;
    in?: Array<ProviderTelehealthVendorsInput | null> | null | undefined;
    nin?: Array<ProviderTelehealthVendorsInput | null> | null | undefined;
    regex?: ProviderTelehealthVendorsInput | null | undefined;
};
export type SpecialInstructionsOperatorsFilterFindManyProviderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FilterProvidersDataEmbedQueryVariables = {
    filter?: FilterFindManyProviderInput | null | undefined;
};
export type FilterProvidersDataEmbedQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"FilterProvidersList_EmbedQuery">;
};
export type FilterProvidersDataEmbedQuery = {
    readonly response: FilterProvidersDataEmbedQueryResponse;
    readonly variables: FilterProvidersDataEmbedQueryVariables;
};



/*
query FilterProvidersDataEmbedQuery(
  $filter: FilterFindManyProviderInput
) {
  ...FilterProvidersList_EmbedQuery
}

fragment FilterProvidersList_EmbedQuery on Query {
  providerConnection(first: 25, filter: $filter, sort: NAME_ASC) {
    edges {
      node {
        _id
        name
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "NAME_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterProvidersDataEmbedQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FilterProvidersList_EmbedQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterProvidersDataEmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProviderConnection",
        "kind": "LinkedField",
        "name": "providerConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProviderEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Provider",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "sort"
        ],
        "handle": "connection",
        "key": "FilterProvidersList_providerConnection",
        "kind": "LinkedHandle",
        "name": "providerConnection"
      }
    ]
  },
  "params": {
    "cacheID": "aaf06fef13aa52c4b7ba42af380717f9",
    "id": null,
    "metadata": {},
    "name": "FilterProvidersDataEmbedQuery",
    "operationKind": "query",
    "text": "query FilterProvidersDataEmbedQuery(\n  $filter: FilterFindManyProviderInput\n) {\n  ...FilterProvidersList_EmbedQuery\n}\n\nfragment FilterProvidersList_EmbedQuery on Query {\n  providerConnection(first: 25, filter: $filter, sort: NAME_ASC) {\n    edges {\n      node {\n        _id\n        name\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '9732dcd82253a8d74e8d0c700f65e5ca';
export default node;
